export default "__VITE_ASSET__d4dc84db__"